module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/lpo_open_rate_lpo-3db7f03452f41e72afffbc193e0467b9.svg";